/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createFieldValueMappingRequestSchema = z.object({
  loopValue: z.string().min(1),
  loopValueId: z.string().nullish(),
  sourceValue: z.string().min(1),
  sourceValueId: z.string().nullish(),
});
